var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [
        _vm._v(" DYNAMIC WORKFLOW APPROVER ")
      ]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_approver.title.$error } },
        [
          _c("label", [_vm._v(" Dynamic Workflow Approver Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: {
              "max-length": 255,
              placeholder: "Workflow Approver Title"
            },
            model: {
              value: _vm.$v.data_approver.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_approver.title, "$model", $$v)
              },
              expression: "$v.data_approver.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_approver.workflow.$error } },
        [
          _c("label", [_vm._v(" Select Workflow ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              options: _vm.workflowList,
              label: "name",
              "value-format": "object",
              placeholder: "Choose Workflow"
            },
            model: {
              value: _vm.$v.data_approver.workflow.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_approver.workflow, "$model", $$v)
              },
              expression: "$v.data_approver.workflow.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_approver.form.$error } },
        [
          _c("label", [_vm._v(" Select Form ")]),
          _vm._v(" "),
          _c("j-single-select", {
            attrs: {
              "load-options": _vm.loadOptionsForm,
              "is-async": true,
              "cache-option": false,
              placeholder: "Choose Form",
              "value-format": "object",
              label: "name"
            },
            model: {
              value: _vm.$v.data_approver.form.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_approver.form, "$model", $$v)
              },
              expression: "$v.data_approver.form.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeApprover }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveApprover } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08ee7ddc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08ee7ddc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jBaktiWorkflowAppSetup.vue
// module id = null
// module chunks = 